import { useContext, useEffect, useLayoutEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AllComponentsWrapper from "./all-components-wrapper.component";
import { languageChangerObject } from "./language";
import { LanguageContext } from './contexts/language.context'

const SITE = "https://autochip.md";

function Layout({ lang }) {
	const { setRomanianLanguage } = useContext(LanguageContext);
	const location = useLocation();
	const { russian, romanian } = languageChangerObject;
	const isRomanian = lang === "ro";
	const content = isRomanian ? romanian : russian;

	const pageUrl = isRomanian ? `${SITE}/` : `${SITE}/ru`;

	const title = isRomanian
		? "Autochip: Chei auto. Electrician auto, diagnosticare"
		: "AutoChip: Автоключи. Автоэлектрик, диагностика";

	const description = isRomanian
		? "Fabricarea si repararea cheilor auto, repararea lacatelor, instalare video registratoare, senzori parcare în Chisinau"
		: "Изготовление и ремонт автоключей, ремонт замков, установка регистратора, парктроника в Кишинёве";

	// Keep LanguageContext (used for image swapping elsewhere) in sync with the URL.
	useEffect(() => {
		setRomanianLanguage(isRomanian);
	}, [isRomanian, setRomanianLanguage]);

	// Scroll to the section named by the hash after this route has mounted.
	// One rAF (not a timer) guarantees the DOM has committed/laid out before we measure.
	// Only fires on router-tracked hash changes (mount, route swap, Back/Forward) —
	// react-scroll nav clicks sync the hash via history.replaceState, which the
	// router doesn't observe, so this never double-fires against a live smooth-scroll.
	useLayoutEffect(() => {
		const raw = location.hash || "";
		if (!raw) return;

		const id = decodeURIComponent(raw.replace("#", ""));

		const rafId = requestAnimationFrame(() => {
			const el = document.getElementById(id);
			if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
		});

		return () => cancelAnimationFrame(rafId);
	}, [location.pathname, location.hash]);

	return (
		<div className="App" style={{ backgroundColor: "#FBFAFE" }}>
			<Helmet>
				<html lang={lang} />
				<title>{title}</title>
				<meta name="description" content={description} />

				<link rel="canonical" href={pageUrl} />
				<link rel="alternate" hrefLang="ro" href={`${SITE}/`} />
				<link rel="alternate" hrefLang="ru" href={`${SITE}/ru`} />
				<link rel="alternate" hrefLang="x-default" href={`${SITE}/`} />

				<meta property="og:url" content={pageUrl} />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />

				<meta name="twitter:title" content={title} />
				<meta name="twitter:description" content={description} />
			</Helmet>

			<AllComponentsWrapper props={content} lang={lang} />
		</div>
	);
}

function App() {
	return (
		<Routes>
			<Route path="/" element={<Layout lang="ro" />} />
			<Route path="/ru" element={<Layout lang="ru" />} />
		</Routes>
	);
}

export default App;
